import Product, { ProductLite } from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { isProductCaviar } from '@src/quince-site-common/src/helpers/productHelper'

export const getDetailsAndCareConfig = (product: Product | ProductLite | Bundle) => {
  let contentContainerDisplayName = 'Product Details, Size & Fit, Care'

  const tabTitles = {
    productDetails: 'DETAILS',
    productSizeAndFit: 'SIZE & FIT',
    productCare: 'CARE',
    productBenefits: 'BENEFITS',
    productIngredients: 'INGREDIENTS',
    productNotes: 'NOTES',
    productInstallation: 'INSTALLATION',
    productSpecs: 'SPECS',
    productDimensions: 'DIMENSIONS',
  }

  const isProductCaviarFlag = isProductCaviar(product)
  if (isProductCaviarFlag) {
    contentContainerDisplayName = 'Product Details, Shelf Life, Shipping'
    tabTitles.productSizeAndFit = 'SHELF LIFE'
    tabTitles.productCare = 'SHIPPING'
  }

  return {
    contentContainerDisplayName,
    tabTitles,
  }
}
